export const SCHEDULE_AN_APPOINTMENT_TITLE_FIRST_PART = 'This store only accepts appointments via telephone. Please call '
export const SCHEDULE_AN_APPOINTMENT_TITLE_SECOND_PART = ' to schedule an appointment or select another store.'
export const APPOINTMENT_SCHEDULE_TITLE = 'APPOINTMENT SCHEDULE'
